import { INIT_DEFINITION_SETTINGS, SCORING_DEFINITION_TYPES } from '../settings/scoringProfilesSettings'

// + operator is used to convert string to number
export const roundToFourDecimals = (num) => +(Math.round(num * 10000) / 10000).toFixed(4)

export function formatDriverWeightNumber(value) {
  return roundToFourDecimals(parseFloat(value) / 100)
}

export function getMaxTotalDriversWeight(list) {
  if (!Array.isArray(list) || list.length === 0) return 0
  const weights = list.map((k) => (!k.weight ? 0 : k.weight))
  const sum = weights.length > 0 ? weights.reduce((a, b) => a + b) : 0
  return roundToFourDecimals(sum)
}

export function getSum(list) {
  return [...list]
    .map((k) => {
      return k.weight
    })
    .reduce((a, b) => a + b, 0)
}

export function calculateGeometricDriverWeight(weight, driversList) {
  const list = driversList.map((j, i) => {
    return {
      ...j,
      weight: Math.pow(weight, i),
    }
  })
  const sum = getSum(list)
  list.forEach((el) => (el.weight = roundToFourDecimals(el.weight / sum)))
  return list
}

export function calculateLinearDriverWeight(driversList) {
  const n = driversList.length
  const denominator = n * (n + 1)
  const list = driversList.map((j, i) => {
    const numerator = 2 * (n + 1 - (i + 1))
    return {
      ...j,
      weight: roundToFourDecimals(numerator / denominator),
    }
  })
  return list
}

export function calculateCustomDriverWeight(driversList) {
  const list = driversList.map((j) => {
    return {
      ...j,
      weight: roundToFourDecimals(j.weight),
    }
  })
  return list
}

export function calculateDriversWeightsLists(driver, list, config, decay, callback) {
  let result = []

  if (driver) {
    list.push({ driver: driver, weight: 0 })
  }

  switch (config) {
    case SCORING_DEFINITION_TYPES.geometric:
      result = calculateGeometricDriverWeight(decay, list)
      break

    case SCORING_DEFINITION_TYPES.custom:
      result = calculateCustomDriverWeight(list)
      break

    case SCORING_DEFINITION_TYPES.linear:
      result = calculateLinearDriverWeight(list)
      break

    default:
      result = list
  }

  return typeof callback !== 'function' ? result : callback(result)
}

export function mapScoringProfileDefinition(settings, data) {
  let scoringDefinitionSettings = settings
  const keys = Object.keys(scoringDefinitionSettings)
  keys.forEach((key) => {
    const config = scoringDefinitionSettings[key].config
    let sourceList = data[config]
    if (config === SCORING_DEFINITION_TYPES.geometric) {
      sourceList = sourceList.drivers.map((j) => {
        return {
          driver: j,
          weight: 0,
        }
      })
    }
    const list = calculateDriversWeightsLists(
      null,
      sourceList,
      config,
      data.geometricDrivers.sequenceWeightsDecay,
      null
    )
    scoringDefinitionSettings[key].list = list
  })
  return scoringDefinitionSettings
}

export function mapDataForFairmatProductScore(obj) {
  // A comparable that is not scored (an excluded one) has no score object at all.
  if (obj == null || Object.keys(obj).length === 0 || obj.scoreResults == null) {
    return
  }

  const score_results = obj.scoreResults

  score_results.map((item) => {
    item['driverDetails'] =
      item['driverDetails'] == null || !('driverDetails' in item)
        ? []
        : item.driverDetails.map((el) => {
            return {
              ...el,
              color: window
                .getComputedStyle(document.documentElement)
                .getPropertyValue('--categoryPrimaryColor' + el.category.toUpperCase()),
            }
          })
  })

  return {
    ...obj,
    scoreResults: score_results,
  }
}

export function mapScoringDefinitionforModel(scoringDefinition) {
  const selectedWeigthType = scoringDefinition.weightType
  const sequenceWeightsDecay = scoringDefinition.geometricDrivers.sequenceWeightsDecay
  let scoringDefinitionList = scoringDefinition[INIT_DEFINITION_SETTINGS()[selectedWeigthType].config]

  if (selectedWeigthType === 1) {
    scoringDefinitionList = scoringDefinitionList.drivers.map((el) => {
      return {
        driver: el,
        weight: 0,
      }
    })
  }

  const list = calculateDriversWeightsLists(
    null,
    scoringDefinitionList,
    INIT_DEFINITION_SETTINGS()[selectedWeigthType].config,
    sequenceWeightsDecay,
    null
  )

  const weights = list.map((el) => el.weight)
  return { driversList: list, sortedWeights: weights }
}
